import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  constructor(@Inject(DOCUMENT) private document: Document) {}
  loadingStatus: Subject<any> = new Subject();
  load: boolean = false;
  activeRequests: number = 0;

  get loading(): boolean {
    return this.load;
  }

  set loading(value) {
    this.load = value;
    this.loadingStatus.next(value);
  }

  executeStartLoading(): void {
    this.loading = true;
    this.document.body.classList.add('loading');
  }

  executeStopLoading(): void {
    this.loading = false;
    this.document.body.classList.remove('loading');
  }

  startLoading(): void {
    if (this.activeRequests === 0) this.executeStartLoading();
    this.activeRequests++;
  }

  stopLoading(): void {
    if (this.activeRequests > 0) this.activeRequests--;
    if (this.activeRequests === 0) this.executeStopLoading();
  }
}
